import ContactForm from '@/components/forms/ContactForm/ContactForm';

interface ContactFormBlockProps {
	data: any;
	blockId: string;
}

export default function ContactFormBlock({ blockId }: ContactFormBlockProps) {
	return (
		<section id={blockId} className="pb-16 md:pb-24 pt-0 bg-gray-50">
			<ContactForm />
		</section>
	);
}
